import { space, colors } from ".";

export const boxShadow = {
  'shadow.1': `0 ${space._400} ${space._400} 0 ${colors["neutral.950"]}`,
}